import React, { useRef, useEffect } from 'react';
import { View, Animated, Easing, StyleSheet, Platform } from 'react-native';

/**
 * Custom animated loading spinner that actually rotates
 * React Native's ActivityIndicator doesn't always animate properly on web
 */
const LoadingSpinner = ({ 
  size = 24, 
  color = 'rgba(255,255,255,0.6)',
  strokeWidth = 2,
  style 
}) => {
  const spinValue = useRef(new Animated.Value(0)).current;
  
  useEffect(() => {
    const spin = Animated.loop(
      Animated.timing(spinValue, {
        toValue: 1,
        duration: 1000,
        easing: Easing.linear,
        useNativeDriver: Platform.OS !== 'web', // Can't use native driver on web for transforms
      })
    );
    spin.start();
    
    return () => spin.stop();
  }, []);
  
  const rotate = spinValue.interpolate({
    inputRange: [0, 1],
    outputRange: ['0deg', '360deg'],
  });
  
  return (
    <Animated.View 
      style={[
        styles.spinner,
        { 
          width: size, 
          height: size,
          transform: [{ rotate }],
        },
        style
      ]}
    >
      <View style={[
        styles.circle,
        {
          width: size,
          height: size,
          borderWidth: strokeWidth,
          borderColor: `${color}30`,
          borderTopColor: color,
          borderRadius: size / 2,
        }
      ]} />
    </Animated.View>
  );
};

const styles = StyleSheet.create({
  spinner: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  circle: {
    backgroundColor: 'transparent',
  },
});

export default LoadingSpinner;

